/**
 * Maps raw `AuditLog` rows (server shape from `GET /admin/audit-logs`) to
 * the `AuditLogEntry` shape `AuditHistoryPanel` renders.
 *
 * Hook-free by design (no `useTranslation`) — callers supply the translated
 * action labeler and unknown-actor fallback string, mirroring the
 * `mediaTypeLabel`/`ownershipLabel` callback pattern in `grant-helpers.ts`.
 */
import type { AuditLog } from '@ooh/contracts';
import type { AuditLogEntry } from './audit-history-panel';

export function formatAuditEntries(
  logs: AuditLog[],
  userNamesById: Map<number, string>,
  roleAffectedName: string,
  actionLabel: (action: string) => string,
  unknownActorLabel: string,
): AuditLogEntry[] {
  return logs.map((log) => ({
    id: log.id,
    timestamp: log.createdAt.toISOString(),
    actor:
      log.userId !== null
        ? (userNamesById.get(log.userId) ?? unknownActorLabel)
        : unknownActorLabel,
    roleAffected: roleAffectedName,
    description: actionLabel(log.action),
  }));
}
